import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthComponent } from '../auth/auth.component';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@doddly/core';
import { InputTextModule } from 'primeng/inputtext';
import { CalloutComponent, IconComponent, LogoComponent } from '@doddly/shared';
import { sendEmailVerification } from '@firebase/auth';

@Component({
  selector: 'ly-create-account',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AuthComponent,
    InputTextModule,
    IconComponent,
    CalloutComponent,
    LogoComponent,
  ],
  templateUrl: './create-account.component.html',
  styleUrl: './create-account.component.scss',
})
export class CreateAccountComponent {
  isProcessing = false;
  errorMessage: string | null = null;
  createAccountForm = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.email, Validators.required],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: Validators.required,
    }),
    displayName: new FormControl('', {
      nonNullable: true,
    }),
    phone: new FormControl('', {
      nonNullable: true,
    }),
  });

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  submit() {
    const email = this.createAccountForm.controls.email.value;
    const password = this.createAccountForm.controls.password.value;
    const displayName = this.createAccountForm.controls.displayName.value;
    const phone = this.createAccountForm.controls.phone.value;

    /**
     * Display name and phone number are hidden, if they are provided, mostlikely it's a bot
     */
    if (displayName || phone) {
      return;
    }

    this.isProcessing = true;
    this.errorMessage = null;

    this.auth
      .createUserWithEmailAndPassword(email, password)
      .then((userCredential) => {
        sendEmailVerification(userCredential.user);
        this.router.navigate(['/']);
      })
      .catch((error) => {
        switch (true) {
          case error.message.includes('email-already-in-use'):
            this.errorMessage = 'Email already exists';
            break;
          case error.message.includes('weak-password'):
            this.errorMessage = 'Password should be at least 6 characters';
            break;
          default:
            this.errorMessage = 'Invalid email or password';
        }
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  signupWithGoogle(): void {
    this.auth.signInWithGoogle().then((userCredential) => {
      sendEmailVerification(userCredential.user);
      this.router.navigate(['/']);
    });
  }
}
